var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"app-footer"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"content"},[_c('h2',{domProps:{"textContent":_vm._s(_vm.language.application.title)}}),_c('p',{domProps:{"textContent":_vm._s(_vm.language.application.subtitle)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }